export type CheckoutReturnStatus = 'success' | 'cancelled' | 'failed' | null;

export type BookingCheckoutReturnState = {
  status: CheckoutReturnStatus;
  orderId: string | null;
  slotId: string | null;
  locationId: string | null;
  lessonTypeId: string | null;
};

export function parseCheckoutReturnState(
  params: URLSearchParams | ReadonlyURLSearchParams
): BookingCheckoutReturnState {
  const checkout = params.get('checkout');
  const status: CheckoutReturnStatus =
    checkout === 'success' || checkout === 'cancelled' || checkout === 'failed' ? checkout : null;

  return {
    status,
    orderId: params.get('order_id'),
    slotId: params.get('slot_id'),
    locationId: params.get('location_id'),
    lessonTypeId: params.get('lesson_type_id'),
  };
}

export function getCheckoutReturnMessage(state: BookingCheckoutReturnState): {
  kind: 'success' | 'error' | null;
  message: string | null;
} {
  if (state.status === 'success') {
    return {
      kind: 'success',
      message:
        'Payment received. We are confirming your booking now. If your booking does not appear shortly, please refresh this page.',
    };
  }

  if (state.status === 'cancelled' || state.status === 'failed') {
    return {
      kind: 'error',
      message:
        'Your payment was not completed. Please return to booking and try again. If the issue continues, contact support.',
    };
  }

  return { kind: null, message: null };
}

export function mapGuestCheckoutError(rawMessage: string): string {
  const normalized = rawMessage.trim().toLowerCase();
  if (
    normalized.includes('stripe') ||
    normalized.includes('payment') ||
    normalized.includes('request failed') ||
    normalized.includes('order') ||
    normalized.includes('checkout')
  ) {
    return 'We could not complete your payment right now. Please try again.';
  }

  if (normalized.includes('selected slot is no longer available')) {
    return 'That slot is no longer available. Please choose another time.';
  }

  if (normalized.includes('availability override')) {
    return 'That slot is no longer available. Please choose another time.';
  }

  return rawMessage || 'We could not complete your booking right now. Please try again.';
}

type ReadonlyURLSearchParams = Pick<URLSearchParams, 'get'>;
